export default function RedirectButton({
  title = "Anchor Title",
  primary = true,
  danger = false,
  target="_self",
  href = "/",
}) {
  return (
    <a
      href={href}
      target={target}
      className={`min-w-40 block py-2 px-4 text-center text-sm rounded-lg ${
        primary
          ? "bg-green-600 text-white font-medium hover:bg-green-700 "
          : "border border-gray-600 text-gray-300 hover:border-green-400"
      }
      ${
        danger && "hover:border-red-500 hover:text-red-500"
      }
      `}
    >
      {title}
    </a>
  );
}
